import React, { Component } from "react";
import { Redirect } from "react-router";
import InputHandler from "../../shared/javascript/InputHandler";
import SubmissionHandler from "../../shared/javascript/SubmissionHandler";
import { RadioGroup } from "../../shared/Components/RadioGroup";
import { CheckboxGroup } from "../../shared/Components/CheckboxGroup";
import { Textbox } from "../../shared/Components/Textbox";
import { LoadingModal } from "../../shared/Components/LoadingModal";
import error_messages from "./error_messages.json";
import paperForm from "../../../pdfs/DENTAL-XTRA-ENROLLMENT-6221.pdf";
import arlogo from "../../../images/arlogo.png";

var inputHandler = new InputHandler(error_messages);
var submissionHandler = new SubmissionHandler(error_messages);

export class Prevalidation extends Component {
  displayName = Prevalidation.name;
  constructor(props) {
    super(props);
    this.state = {
      user_browser: navigator.userAgent,
      endpoint: "/api/arkansas/dentalforhealth/prevalidate",
      errors: {
        referral: "",
        other_referral: "",
        conditions: "",
        member_id: "",
        group_number: "",
        default_error: ""
      },
      user_input: {
        referrals: {
          selected_option: "",
          options: {
            special_delivery_nurse: {
              label: "Special Delivery Nurse",
              is_checked: false
            },
            case_manager: {
              label: "Case Manager",
              is_checked: false
            },
            dental_office: {
              label: "Dental Office",
              is_checked: false
            },
            care_coordinator: {
              label: "Care Coordinator",
              is_checked: false
            },
            other: {
              label: "Other",
              is_checked: false
            }
          }
        },
        other_referral: "",
        conditions: {
          diabetes: {
            label: "Diabetes",
            is_checked: false
          },
          coronary_artery_disease: {
            label: "Coronary Artery Disease",
            is_checked: false
          },
          stroke: {
            label: "Stroke",
            is_checked: false
          },
          oral_cancer: {
            label: "Oral Cancer",
            is_checked: false
          },
          head_and_neck_cancer: {
            label: "Head and Neck Cancer",
            is_checked: false
          },
          sjogrens: {
            label: "Sjögren's Syndrome",
            is_checked: false
          },
          pregnancy: {
            label: "Pregnancy",
            is_checked: false
          },
					copd: {
            label: "Chronic Obstructive Pulmonary Disease",
            is_checked: false
          },
					esrd: {
            label: "End State Renal Disease",
            is_checked: false
          },
					mets: {
            label: "Metabolic Syndrome",
            is_checked: false
          },
        },
        member_id: "",
        group_number: ""
      },
      form_is_valid: false,
      is_loading: false,
      success: false
    };
  }

  render = () => {
    const {
      errors,
      user_input,
      is_loading,
      form_is_valid,
      success
    } = this.state;

    var referenceTextDisplay = <br />;
    // if 'other' under referral is selected, allow user to enter text
    if (user_input.referrals.selected_option === "other") {
      referenceTextDisplay = (
        <div className="row">
          <div className="col-md-6">
            <Textbox
              label_name="Please tell us who referred you."
              name="other_referral"
              placeholder="Other Referral"
              maxLength="25"
              onChange={e => inputHandler.handleBasicInputChange(e, this)}
              required={true}
            />
            {errors.other_referral}
          </div>
        </div>
      );
    } else if (user_input.referrals.selected_option !== "other") {
      // assure submission is available if user clicks away from 'other'
      user_input.other_referral = "";
      errors.other_referral = "";
    }

    var page = (
      <div className="container padding-top">
        <h1>Enroll in Dental Xtra</h1>
        <div className="alert alert-info alert-dismissable">
          <button
            type="button"
            className="close button button-primary buttonBlue close-btn"
            data-dismiss="alert"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <p>
            Members with an Arkansas Blue Cross dental insurance policy may qualify 
            for Dental Xtra if they are pregnant, have diabetes, coronary artery 
            disease, stroke, oral cancer, head & neck cancer, Sjӧgren’s syndrome, 
            chronic obstructive pulmonary disease, end-stage renal disease or 
            metabolic syndrome.
          </p>
          <p>
            If you also have a medical policy through Arkansas Blue Cross and
            have a qualifying medical condition, it is possible that you have
            already been automatically enrolled into Dental Xtra. All members
            enrolled receive a welcome letter confirming enrollment and details
            about the additional benefits offered through Dental Xtra. Note: It
            may take up to a month for us to process your enrollment. Once your
            enrollment is processed, you will receive a welcome letter in the
            mail. For more information about Dental Xtra benefits or
            eligibility, contact Customer Service at 1-888-223-4999.
          </p>
        </div>
        <p>
          You may also print and mail a <a href={paperForm}>paper form</a> to
          enroll.
        </p>
        <div className="align-right">
          <a href="https://ar-dentalxtra.dentaltotalhealth.com/">
            Back to Dental Xtra main page
          </a>
        </div>
        <hr />
        <h3>Member Enroll</h3>
        <RadioGroup
          label_name="How did you hear about Dental Xtra Benefits?"
          radioButtons={user_input.referrals}
          required={true}
          onChange={e =>
            inputHandler.handleRadioGroupChange(e, this, "referrals")
          }
        />
        {referenceTextDisplay}
        {errors.referrals}
        <CheckboxGroup
          name="conditions"
          label_name="Check the program qualifying condition(s) that you have:"
          checkboxes={user_input.conditions}
          onChange={e =>
            inputHandler.handleCheckboxGroupChange(e, this, "conditions")
          }
          required={true}
        ></CheckboxGroup>
        {errors.conditions}
        <br />
        <div className="row">
          <div className="col-md-6">
            <Textbox
              name="member_id"
              label_name="Member Being Enrolled ID"
              required={true}
              placeholder="Member ID"
              maxLength="11"
              onChange={e => inputHandler.handleBasicInputChange(e, this)}
            />
            {errors.member_id}
          </div>
          <div className="col-md-6">
            <Textbox
              name="group_number"
              label_name="Group/Division Number"
              required={true}
              placeholder="Group Number"
              maxLength="6"
              onChange={e => inputHandler.handleBasicInputChange(e, this)}
            />
            {errors.group_number}
          </div>
        </div>
        <h3>Sample ID Cards:</h3>
        <div className="row">
          <div className="col">
            <div className="row id-card-display">
              <div>
                <div className="id-card">
                  <div className="row">
                    <img className="id-card-logo" src={arlogo} />
                    <div className="col">
                      <div className="col">Arkansas</div>
                      <div className="col">BlueCross BlueShield</div>
                    </div>
                  </div>
                  <hr />
                  <p>MEMBER NAME</p>
                  <p>JOHN DOE</p>
                  <p>MEMBER ID #</p>
                  <p>
                    LVS
                    <span className="highlight-card-text card-tooltip">
                      M12345678
                      <span className="tooltiptext">
                        Please enter only the highlighted digits. Any digits
                        before the 'M' should not be entered and the last two
                        digits should not be entered.
                      </span>
                    </span>
                    00
                  </p>
                  <hr />
                  <div className="row">
                    <p className="col">
                      DIVISION #{" "}
                      <span className="highlight-card-text card-tooltip">
                        010061
                        <span className="tooltiptext">
                          Please enter only the first 6 digits of the division #
                          displayed on your ID card.
                        </span>
                      </span>
                      1001
                    </p>
                    <p className="col">
                      LIFE SPECIALTY VENTURES, LLC DENTAL PLAN
                    </p>
                  </div>
                </div>
                <div className="row">
                  <div className="id-card-info col">
                    Please enter only the highlighted digits. Any digits before
                    the 'M' should not be entered and the last two digits should
                    not be entered.
                  </div>
                </div>
                <div className="row">
                  <div className="id-card-info col">
                    Please enter only the first 6 digits of the division #
                    displayed on your ID card.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col">
            <div className="row id-card-display">
              <div>
                <div className="id-card">
                  <div className="row">
                    <img className="id-card-logo" src={arlogo} />
                    <div className="col">
                      <div className="col">Arkansas</div>
                      <div className="col">BlueCross BlueShield</div>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col">
                      <p>MEMBER NAME</p>
                      <p>JOHN DOE</p>
                      <p>MEMBER ID:</p>
                      <p>
                        <span className="card-tooltip highlight-card-text">
                          990544213
                          <span className="tooltiptext">
                            Please enter only the highlighted digits. The last
                            two digits should not be entered.
                          </span>
                        </span>
                        01
                      </p>
                    </div>
                    <div className="col">
                      <p>MEMBER DOB:</p>
                      <p>01/01/1900</p>
                      <p>Group #</p>
                      <p>
                        <span className="card-tooltip highlight-card-text">
                          399040
                          <span className="tooltiptext">
                            Please enter only the first 6 digits of the group #
                            displayed on your ID card.
                          </span>
                        </span>
                        -8
                      </p>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col"></div>
                    <div className="col">
                      <p>FULLY INSURED DENTAL PLAN</p>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="id-card-info col">
                    Please enter only the highlighted digits. The last two
                    digits should not be entered.
                  </div>
                </div>
                <div className="row">
                  <div className="id-card-info col">
                    Please enter only the first 6 digits of the group #
                    displayed on your ID card.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div className="form-group">
          <input
            disabled={!form_is_valid}
            type="submit"
            className="btn btn-secondary"
            onClick={e =>
              submissionHandler.BuildARPrevalidation(this).handleSubmit(e)
            }
            value="Check Eligibility"
          />
          <div aria-hidden="true" id="required-description">
            <span aria-hidden="true" className="text-danger">
              *
            </span>
            Required field
          </div>
        </div>
        {errors.default_error}
      </div>
    );

    var modal = null;
    if (is_loading) {
      modal = <LoadingModal />;
    }

    var currentRoute = window.location.href.replace(/^.*\/\/[^\/]+/, "");
    var validationRoute = "/ar/dentalforhealth/validate";
    if (success && currentRoute !== validationRoute) {
      return (
        <Redirect
          to={{
            pathname: validationRoute,
            user_input,
            success
          }}
        />
      );
    }

    return (
      <div>
        {page}
        {modal}
      </div>
    );
  };
}
